// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Auto-refresh hook for node widgets
 *
 * Automatically subscribes to workspace:changed events and triggers refresh.
 * Node implementations don't need to manually subscribe - this is handled automatically.
 */

import { useEffect } from 'react'
import { nodeEvents } from '@/app-shell/events'

export function useWorkspaceRefresh(onRefresh: () => void): void {
  useEffect(() => {
    const unsubscribe = nodeEvents.subscribe('workspace:changed', onRefresh)
    return unsubscribe
  }, [onRefresh])
}
